/** Cài đặt → tiền tệ theo công ty và tỷ giá quy đổi đơn giá (yêu cầu v1.8 mục 6.2, 6.3; 11/10/2026). */
export const fxSettingsEn = {
  title: "Currencies by company & price conversion rates",
  description: "Default currency of each company for new PIs and new products, and the rates used when a PI line converts a product unit price.",
  regionTitle: "Default currency by company",
  regionHint: "A new PI takes the currency of its customer's company; a new product takes the currency of the creator's company. Any of the four currencies can still be chosen on the record.",
  default_vietnam: "Vietnam",
  default_china: "China",
  ratesTitle: "Product price currency conversion",
  ratesHint: "One rate per pair, written with its direction. The reverse direction uses the same rate (RMB → USD divides by the USD → RMB rate). Leave a pair empty until it is agreed: conversion for that pair is then blocked with a prompt to set it here.",
  rateAria: "Rate: 1 {{base}} equals how many {{quote}}",
  notSet: "not set",
  notSetHint: "No rate — conversion blocked",
  invalid: "Enter a positive number with a dot for decimals and no commas (e.g. 6.6 or 25400), up to 8 decimals",
  bigChange: "Differs by more than 20% from the saved rate ({{saved}}) — check the number before saving.",
  updatedAt: "Set {{at}}",
  savedPiNote: "Changing a rate only affects conversions made afterwards. A saved PI keeps its original currency, original unit price, the rate it used and the converted price; product prices are never overwritten.",
};

export const fxSettingsVi: typeof fxSettingsEn = {
  title: "Tiền tệ theo công ty & tỷ giá quy đổi đơn giá",
  description: "Tiền tệ mặc định của từng công ty cho PI và sản phẩm mới, và tỷ giá dùng khi một dòng PI quy đổi đơn giá sản phẩm.",
  regionTitle: "Tiền tệ mặc định theo công ty",
  regionHint: "PI mới lấy tiền tệ theo công ty của khách; sản phẩm mới lấy theo công ty của người lập. Trên từng bản ghi vẫn chọn được bất kỳ tiền tệ nào trong bốn tiền tệ.",
  default_vietnam: "Việt Nam",
  default_china: "Trung Quốc",
  ratesTitle: "Quy đổi tiền tệ đơn giá sản phẩm",
  ratesHint: "Mỗi cặp một tỷ giá, ghi rõ chiều. Chiều ngược dùng chính tỷ giá đó (RMB → USD là chia cho tỷ giá USD → RMB). Cặp chưa thống nhất thì để trống: quy đổi cặp đó bị chặn kèm lời nhắc đặt tỷ giá ở đây.",
  rateAria: "Tỷ giá: 1 {{base}} bằng bao nhiêu {{quote}}",
  notSet: "chưa đặt",
  notSetHint: "Chưa có tỷ giá — chặn quy đổi",
  invalid: "Nhập số dương, dùng dấu chấm cho phần thập phân, không dùng dấu phẩy (ví dụ 6.6 hoặc 25400), tối đa 8 chữ số lẻ",
  bigChange: "Lệch hơn 20% so với tỷ giá đã lưu ({{saved}}) — kiểm lại con số trước khi lưu.",
  updatedAt: "Đặt lúc {{at}}",
  savedPiNote: "Đổi tỷ giá chỉ áp cho những lần quy đổi sau đó. PI đã lưu giữ nguyên tiền tệ gốc, đơn giá gốc, tỷ giá đã áp và giá sau quy đổi; giá sản phẩm không bao giờ bị ghi đè.",
};

export const fxSettingsZh: typeof fxSettingsEn = {
  title: "各公司币种与价格换算汇率",
  description: "各公司新建 PI 与新产品的默认币种，以及 PI 明细换算产品单价时所用的汇率。",
  regionTitle: "各公司默认币种",
  regionHint: "新 PI 采用客户所属公司的币种；新产品采用创建人所属公司的币种。各单据仍可从四种币种中任选。",
  default_vietnam: "越南",
  default_china: "中国",
  ratesTitle: "产品价格币种换算",
  ratesHint: "每组币种只设一个汇率，并标明方向。反方向使用同一汇率（RMB → USD 即除以 USD → RMB 汇率）。尚未确定的币种组请留空：该组换算会被阻止，并提示先在此设置。",
  rateAria: "汇率：1 {{base}} 等于多少 {{quote}}",
  notSet: "未设置",
  notSetHint: "未设汇率——不可换算",
  invalid: "请输入正数，小数用句点、不要用逗号（例如 6.6 或 25400），最多 8 位小数",
  bigChange: "与已保存的汇率（{{saved}}）相差超过 20%，保存前请核对数字。",
  updatedAt: "设置于 {{at}}",
  savedPiNote: "修改汇率只影响之后的换算。已保存的 PI 保留原币种、原单价、所用汇率及换算后价格；产品价格永不被覆盖。",
};
